<template>
  <b-row>
    <b-colxx xxs="12">
      <b-card class="mb-4" title="개별 옵션 종료">
        <b-tabs content-class="m-4" active-nav-item-class="font-weight-bold text-danger">
          <b-tab :title="'판매중 (' + this.optionList.length +')'">
            <option-list :data="optionList" buttonLabel="일시중지" @onSave="salesSave"/>
          </b-tab>
          <b-tab :title="'일시중지 (' + this.stopOptionList.length+')'">
            <option-list :data="stopOptionList" buttonLabel="판매중" @onSave="salesSave"/>
          </b-tab>
        </b-tabs>

      </b-card>
    </b-colxx>
  </b-row>
</template>
<script>
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import EditOptionList from './components/EditOptionList'
import api from "../../constants/api";

export default {
  components: {
    'v-select': vSelect,
    'option-list': EditOptionList,
  },
  data() {
    return {
      goodsId: this.$route.params.registerId,
      optionList: [],
      stopOptionList: []
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },

  mounted() {
    this.loadData()
  },

  methods: {

    //옵션 리스트
    loadData() {
      this.optionList = []
      this.stopOptionList = []

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.options)
      const params = {
        goodsId: this.goodsId
      }

      this.$http.get(reqURL, {
        params: params,
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          ;

          res.data.data.options.forEach((val, idx) => {

            if(val.onSale) {

              this.optionList.push({
                optionId: val.optionId,
                optionName: val.optionName,
                listPrice: val.listPrice,
                salePrice: val.salePrice,
                saleStatus: 'true',
                selected: false
              })

            } else {

              this.stopOptionList.push({
                optionId: val.optionId,
                optionName: val.optionName,
                listPrice: val.listPrice,
                salePrice: val.salePrice,
                saleStatus: 'false',
                selected: false
              })

            }

          });
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },

    //옵션 판매 중지/재개
    salesSave(optionList, buttonLabel) {
      let optionIdArr = []
      let reqURL = ''

      //판매재개
      if(buttonLabel == "판매중") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.optionsResumeSales)
        optionList.forEach((Value, Index) => {
          if(Value.saleStatus == 'true') {
            optionIdArr.push(Value.optionId)
          }
        });
      }

      //판매중지
      else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.optionsStopSales)
        optionList.forEach((Value, Index) => {
          if(Value.saleStatus == 'false') {
            optionIdArr.push(Value.optionId)
          }
        });
      }

      const params = {
        goodsId: this.goodsId,
        optionIds: optionIdArr
      }

      console.log(params);
      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          alert("적용되었습니다. ")
          this.$router.go(0)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    }
  },

  watch: {
    optionList() {
    },
    stopOptionList() {
    }
  }

}
</script>

